export enum ButtonType {
    FILLED_PRIMARY,
    FILLED_SECONDARY,
    FILLED_TERTIARY,
    FILLED_DANGER,
    OUTLINED_PRIMARY,
    OUTLINED_SECONDARY,
    OUTLINED_TERTIARY,
    OUTLINED_DANGER
}
